import type { QueryClientConfig } from "@tanstack/react-query";

/**
 * Configuração do React Query com foco em SEGURANÇA
 *
 * IMPORTANTE: O cache do React Query é limpo automaticamente pelo AuthContext
 * quando há logout ou troca de usuário. Estas configurações complementam
 * essa proteção garantindo que dados não fiquem stale por muito tempo.
 */
export const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      // Cache moderado - dados ficam fresh por 2 minutos
      // Isso evita requests excessivos mas não mantém dados stale por muito tempo
      staleTime: 2 * 60 * 1000, // 2 minutos

      // Garbage collection - limpar dados não usados após 5 minutos
      gcTime: 5 * 60 * 1000, // 5 minutos

      // Retry limitado para erros de rede
      retry: 2,
      retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 10000),

      // SEGURANÇA: Refetch ao voltar para a janela
      // Isso garante que dados sejam atualizados quando o usuário voltar ao app
      refetchOnWindowFocus: true,

      // SEGURANÇA: Refetch ao reconectar
      // Garante dados frescos após perda de conexão
      refetchOnReconnect: true,

      // Não refetch automaticamente em mount (deixar para os hooks individuais)
      refetchOnMount: true,

      // SEGURANÇA: Não usar dados de cache enquanto revalida em casos críticos
      // Hooks individuais podem sobrescrever se necessário
      networkMode: 'online',
    },
    mutations: {
      retry: 0,
      // Mutations nunca devem ser cacheadas
      networkMode: 'online',
    },
  },
};

